import { Global } from '@emotion/core';
import { css } from 'emotion';
import React from 'react';
import Carousel from 'react-bootstrap/lib/Carousel';
import { Chevron } from '../../../../components/Chevron';
import { BroadcastIcon } from '../../../../shared/Icon/components/BroadcastIcon';
import { FreeIcon } from '../../../../shared/Icon/components/FreeIcon';
import MicrophoneIcon from '../../../../shared/Icon/components/MicrophoneIcon';
import {
  CarouselGlobalStyles,
  Copy,
  DesktopWrapper,
  Header,
  IconWrapper,
  MobileWrapper,
  ValuePropositionContainer,
} from './styles';

type Icon = 'microphone' | 'broadcast' | 'free';
type ValueProposition = {
  header: string;
  copy: string;
  icon: Icon;
};

const VALUE_PROPOSITION_LIST: ValueProposition[] = [
  {
    header: 'Create without constraints',
    copy:
      'Record and edit remotely with intuitive tools designed for all podcasters.',
    icon: 'microphone',
  },
  {
    header: 'Get heard everywhere',
    copy:
      'Distribute your show to Spotify, Apple Podcasts, and more—with just one click.',
    icon: 'broadcast',
  },
  {
    header: '100% free',
    copy:
      'No hosting limits, no trial periods, and you own your content forever.',
    icon: 'free',
  },
];

export function ValuePropositions() {
  return (
    <>
      <DesktopWrapper>
        {VALUE_PROPOSITION_LIST.map(valueProp => {
          const { header, copy, icon } = valueProp;
          return (
            <ValueProposition
              key={`value-prop-${header}`}
              header={header}
              copy={copy}
              icon={icon}
            />
          );
        })}
      </DesktopWrapper>
      <MobileWrapper>
        <Global styles={CarouselGlobalStyles} />
        <Carousel
          interval={null}
          prevIcon={
            <Chevron
              direction="left"
              className={css`
                border-color: #5000b9;
              `}
            />
          }
          nextIcon={
            <Chevron
              direction="right"
              className={css`
                border-color: #5000b9;
              `}
            />
          }
        >
          {VALUE_PROPOSITION_LIST.map(valueProp => {
            const { header, copy, icon } = valueProp;
            return (
              <Carousel.Item key={`value-prop-mobile-${header}`}>
                <ValueProposition header={header} copy={copy} icon={icon} />
              </Carousel.Item>
            );
          })}
        </Carousel>
      </MobileWrapper>
    </>
  );
}

function ValueProposition({ header, copy, icon }: ValueProposition) {
  return (
    <ValuePropositionContainer>
      <IconWrapper>{getIcon(icon)}</IconWrapper>
      <Header>{header}</Header>
      <Copy>{copy}</Copy>
    </ValuePropositionContainer>
  );
}

function getIcon(icon: Icon) {
  switch (icon) {
    case 'microphone':
      return <MicrophoneIcon fillColor="#fff" />;
    case 'broadcast':
      return <BroadcastIcon fillColor="#fff" />;
    case 'free':
    default:
      return <FreeIcon fillColor="#fff" />;
  }
}
